// src/store/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  users: [], // Array to store users
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    createUser: (state, action) => {
      state.users.push(action.payload);
    },
    modifyUser: (state, action) => {
      const index = state.users.findIndex(
        (user) => user.id === action.payload.id
      );
      if (index !== -1) {
        state.users[index] = action.payload;
      }
    },
    deleteUser: (state, action) => {
      state.users = state.users.filter((user) => user.id !== action.payload.id);
    },
    resetUsers: (state) => {
      state.users = [];
    },
  },
});

export const { createUser, modifyUser, deleteUser, resetUsers } = userSlice.actions;
export default userSlice.reducer;